package top.wcpe.allincore.ui.web.docs

/**
 * FR-UI-069 docs manifest 合同模型。
 * 字段与 ui-docs/docs-manifest.json 对齐；解析失败时抛中文诊断。
 */
internal data class DocsManifest(
    val schemaVersion: Int,
    val components: List<DocsComponentEntry>,
)

internal data class DocsComponentEntry(
    val id: String,
    val displayName: String,
    val category: String,
    val order: Int,
    val sourcePath: String,
    val examples: List<DocsExampleEntry>,
    val props: List<DocsPropEntry>,
    val themes: List<String>,
    val capabilities: DocsCapabilities,
    val limits: List<String>,
    val dependencies: DocsDependencies,
)

internal data class DocsExampleEntry(
    val id: String,
    val title: String,
    val entry: String,
)

internal data class DocsPropEntry(
    val name: String,
    val required: Boolean,
    val type: String,
    val defaultValue: String?,
    val description: String,
)

internal data class DocsCapabilities(
    val web: String,
    val jcef: String,
    val fabric: String,
)

internal data class DocsDependencies(
    val components: List<String>,
    val themes: List<String>,
    val mocks: List<String>,
    val models: List<String>,
    val textures: List<String>,
)

internal sealed class DocsRoute {
    data object Home : DocsRoute()
    data class Component(val id: String) : DocsRoute()
    data class NotFound(val raw: String) : DocsRoute()
}

internal fun parseDocsRoute(hash: String): DocsRoute {
    val cleaned = hash.removePrefix("#").trim()
    if (cleaned.isEmpty() || cleaned == "/" || cleaned == "/components") return DocsRoute.Home
    val prefix = "/components/"
    if (!cleaned.startsWith(prefix)) return DocsRoute.NotFound(cleaned)
    // 仅允许单一 id 段：#/components/<id>[?query]；额外路径段一律 404
    val remainder = cleaned.removePrefix(prefix)
    val pathOnly = remainder.substringBefore('?')
    if (pathOnly.isEmpty() || '/' in pathOnly) return DocsRoute.NotFound(cleaned)
    val id = decodeDocsSegment(pathOnly)
    if (id.isEmpty() || '/' in id || id.contains("..") || !DOCS_ID_PATTERN.matches(id)) {
        return DocsRoute.NotFound(cleaned)
    }
    return DocsRoute.Component(id)
}

internal fun encodeDocsComponentHash(id: String): String = "#/components/${encodeURIComponent(id)}"

private val DOCS_ID_PATTERN = Regex("^[a-z0-9][a-z0-9\\-]*$")

private fun decodeDocsSegment(raw: String): String = try {
    decodeURIComponent(raw)
} catch (_: Throwable) {
    ""
}

private fun encodeURIComponent(value: String): String =
    js("encodeURIComponent").unsafeCast<(String) -> String>()(value)

private fun decodeURIComponent(value: String): String =
    js("decodeURIComponent").unsafeCast<(String) -> String>()(value)
